import styled from 'styled-components';
/**
 * Navigation action sheet items container
 */
export const NavigationActionSheetItemContainer = styled.li ``;
